import {createFileRoute} from '@tanstack/react-router';
import {KnowYourCustomerSuccessScreen} from 'pages/kyc/KnowYourCustomerSuccessScreen';

export const Route = createFileRoute('/_protected/kyc/success')({
  component: KnowYourCustomerSuccessScreen,
  validateSearch: (params: {mode?: string}) => {
    const mode = `${params?.mode}`;
    return {
      mode: ['self-initiated', 'mandatory'].includes(mode) ? mode : 'mandatory',
    };
  },
});
